import type { SkillSummary } from "@tabbio/types";
import { GulfFlagIcon } from "@/components/icons/UaeFlagIcon";
import { HugeIcon } from "@/components/icons/HugeIcon";
import { SKILL_CATALOG_ICONS } from "@/components/icons/icon-contracts";
import { skillCatalogVisual } from "./skill-taxonomy";

// The round discs are self-contained circles with their own rim highlight, so
// they fill the slot instead of sitting inside it the way the old 4:3
// rectangles had to. Pan-Gulf skills are not a country, so they fly the globe
// disc; `gulfExecutive` is the catalog key for that audience.
const PAN_GULF_ICON_KEYS = new Set(["gulfExecutive"]);
const FLAG_SLOT_RATIO = 0.92;

export function SkillCatalogIcon({
  skill,
  size = 48,
}: {
  skill: SkillSummary;
  size?: number;
}) {
  const visual = skillCatalogVisual(skill);
  const isPanGulf =
    visual.kind === "hugeicon" && PAN_GULF_ICON_KEYS.has(visual.key);
  if (visual.kind === "flag" || isPanGulf) {
    return (
      <span
        style={{
          width: size,
          height: size,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <GulfFlagIcon
          region={visual.kind === "flag" ? visual.region : "gulf"}
          size={Math.round(size * FLAG_SLOT_RATIO)}
        />
      </span>
    );
  }
  return (
    <span
      style={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {visual.kind === "image" ? (
        <img
          src={visual.uri}
          alt=""
          width={size}
          height={size}
          style={{ objectFit: "contain" }}
        />
      ) : (
        <HugeIcon
          icon={SKILL_CATALOG_ICONS[visual.key]}
          size={Math.round(size * 0.58)}
          color="currentColor"
          strokeWidth={1.75}
        />
      )}
    </span>
  );
}
